export { default } from './CategoryDetailRight';
